module.exports = __webpack_public_path__ + "img/newtaiyo1.c29c5b36.png";